import { Printer } from '../../masterdata/models/printer';
import { CovidSamples } from './covid-sample';
import { UnboxedSample } from './unboxing-sample';
import { MergedBatch } from './merged-batch';
import { Comment } from './comment';
import { ChannelTestingTypeMapping } from './channel-testing-type-mapping';
import { BatchSampleUpdates } from './sample-update';
import { ArchiveBatchSearchFilter } from './archiveBatchSearchFilter';
import { WorkFlow } from '../../masterdata/models/workFlow';

export class AnimalBatch {
    _id: string;
    version: number;
    userID: string;
    creationDate: Date;
    lab: string;
    labName: string;
    batchID: string;
    sender: string;
    count: number;
    puidUnboxing: string;
    receptionDateTime: Date;
    samplingDateTime: Date;
    puidController1: string;
    puidController2: string;
    completenessCheckDateTime: Date;
    rnaPlateID: string;
    machineName: string;
    puidExtraction: string;
    puidStartExtraction: string;
    puidStartExtractor: string;
    startExtraction: Date;
    startExtractorDateTime: Date;
    samples: CovidSamples[];
    completionDateTimeExtraction: Date;
    pcrPlateID: string;
    machineName1: string;
    puidPCR1: string;
    puidPCR2: string;
    startDatePCR: Date;
    completionDateTimePCR: Date;
    splitBatchDateTime: Date;
    puidSplitBatch: string;
    kitLot: string;
    cpValuePCRPC: string;
    qcRangeCpValue: string;
    puidEvaluation: string;
    completionDateTimeEvaluation: Date;
    resultFileNames: string;
    resultDispatchedyPUID: string;
    resultSentDateTime: Date;
    positiveResultCount: number;
    comment: string;
    statusOfTheBatch: string;
    previousStatusOfTheBatch: string;
    analysisStartedPUID: string;
    analysisStartedDateTime: Date;
    excelUploadCreatedAt: Date;
    excelUploadCreatedBy: string;
    redoPUID: string;
    redoDateTime: Date;
    ntcOk: boolean;
    ipcOk: boolean;
    extractionKitVendor: string;
    rtPCRKitVendor: string;
    clippingStartDateTime: Date;
    puidClipping: string;
    clippingCompletionDateTime: Date;
    puidCompleteClipping: string;
    lysisStartDateTime: Date;
    puidstartLysis: string;
    lysisCompletionDateTime: Date;
    puidCompleteLysis: string;
    receivedDnaDateTime: Date;
    receivedDnaPUID: string;
    completeBatchDateTime: Date;
    completeBatchPUID: string;
    //bach creation
    product: string;
    labelCopies: number;
    rushSample: boolean;
    superRush: boolean;
    locked: boolean;
    ncSample: boolean;
    printer: Printer;
    swabType: string;
    unboxedSamples: UnboxedSample[];
    redoUnboxedSamples: UnboxedSample[];
    redoSampleList: string[];
    deleteSampleFromUnboxedList: string[];
    unboxedSamplesForReceived: UnboxedSample[];
    scanCompletePUID: string;
    scanCompleteDateTime: Date;
    unboxedCountOfSampleList: number;
    sampleListSizeWithoutControls: number;
    deliveryReceivedDateTime: Date;
    sampleOrigin: string;
    wellType: WellType;
    sourceBatchIds: string[] = [];
    precyclingStartDateTime: Date;
    puidstartPrecycling: string;
    precyclingCompletionDateTime: Date;
    puidCompletePrecycling: string;
    mergedBatches: MergedBatch[];
    samplesMap: any;
    systemResult: boolean;
    finalResult: string;
    resultUploaded: boolean;
    registeredUnboxedSamples: any;

    scannedBarcodes: string[] = [];
    scannedControls: CovidSamples[] = [];
    chemicalInfoWithLotNos: any;
    chemicalInfoWithCpValues: any;
    redoCount: number;
    redoStatus: string;
    username: string;
    password: any[] = [];
    eventForAuthorization: boolean;

    comments: Comment[] = [];
    ixoUploaded: boolean;
    mergeGroup: string;

    puidUndoMerge: string;
    undoMergeDateTime: Date;

    redoReason: string;
    redoStep: string;
    negativeCount: number;
    invalidCount: number;
    failedICRCount: number;

    analysisVerificationDateTime: Date;
    analysisVerificationPUID: string;
    externalUploadDateTime: Date;
    externalUploadPUID: string;
    readmeFileComment: string;
    cyclerManufacturer: string;
    quadrant: string;

    channelTestingTypeMapping: ChannelTestingTypeMapping[] = [];
    csvFiles: Set<string>;
    filesPerManufacturer: FilesPerManufacturer[];
    history: BatchHistory[];

    archiveBatchSources: string[];
    verifiedArchiveBatchSources: string[];
    archiveProcessedPUID: string;
    archiveProcessedDateTime: Date;
    batchSampleUpdateList: BatchSampleUpdates[];

    reAnalysedByPUID: string;
    reAnalysedDateTime: Date;

    createdFromAnalysis: boolean;

    searchCriteria: ArchiveBatchSearchFilter;
    carrierId?: string;
    redoChannel: string;
    exported: boolean;

    canceledPUID: string;
    canceledDateTime: Date;
    
    workFlowName:string;
    workFlow: WorkFlow;
}

export enum WellType {
    WELL96 = "WELL96",
    WELL384 = "WELL384"
}

export class FilesPerManufacturer {
    fileName: string;
    fileType: string;
}

export class BatchHistory {
    currentBatch: string;
    originalBatch: string;
}
